import React from 'react';
import { useNavigate } from 'react-router-dom';

const WhyChooseUsSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-primary mb-4">Why Choose Evie Outdoors?</h2>
          <p className="text-xl text-gray-600">Built for Canadian Living</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="bg-white rounded-lg p-6 shadow-md">
              <div className="text-3xl mb-4">❄️</div>
              <h3 className="text-lg font-semibold text-primary mb-2">Built for Canadian Winters</h3>
              <p className="text-gray-600">Tested to handle snow, ice, and wind.</p>
            </div>
          </div>
          
          <div className="text-center">
            <div className="bg-white rounded-lg p-6 shadow-md">
              <div className="text-3xl mb-4">🔧</div>
              <h3 className="text-lg font-semibold text-primary mb-2">Professional Installation</h3>
              <p className="text-gray-600">CSA electrical, insured & WSIB-covered installers.</p>
            </div>
          </div>
          
          <div className="text-center">
            <div className="bg-white rounded-lg p-6 shadow-md">
              <div className="text-3xl mb-4">🎨</div>
              <h3 className="text-lg font-semibold text-primary mb-2">Custom Design</h3>
              <p className="text-gray-600">Tailored to your space and style preferences.</p>
            </div>
          </div>
          
          <div className="text-center">
            <div className="bg-white rounded-lg p-6 shadow-md">
              <div className="text-3xl mb-4">🛡️</div>
              <h3 className="text-lg font-semibold text-primary mb-2">Warranty Protection</h3>
              <p className="text-gray-600">Comprehensive coverage for peace of mind.</p>
            </div>
          </div>
        </div>

        {/* Product Selection */}
        <div className="mt-16 text-center">
          <h3 className="text-2xl font-bold text-primary mb-8">What Are You Looking For?</h3>
          
          <div className="grid md:grid-cols-2 gap-8 max-w-2xl mx-auto">
            <div
              className="text-center cursor-pointer"
              onClick={() => navigate('/pergolas')}
            >
              <div className="bg-accent/10 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-6 hover:bg-accent/20 transition-colors">
                <span className="text-3xl">🏗️</span>
              </div>
              <h3 className="text-xl font-semibold text-primary mb-3">Pergolas</h3>
              <p className="text-gray-600">For structure & all-weather use</p>
            </div>
            
            <div
              className="text-center cursor-pointer"
              onClick={() => navigate('/awnings')}
            >
              <div className="bg-accent/10 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-6 hover:bg-accent/20 transition-colors">
                <span className="text-3xl">☂️</span>
              </div>
              <h3 className="text-xl font-semibold text-primary mb-3">Awnings</h3>
              <p className="text-gray-600">For shade & weather protection</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
